import { BAILocale } from '.';
import fi_FI from 'antd/es/locale/fi_FI';

const localeValue: BAILocale = {
  lang: 'fi',
  antdLocale: fi_FI,
};

export default localeValue;
